import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import api from '../../services/api';
import './EmailVerificationBanner.css';

export default function EmailVerificationBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [resending, setResending] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // 'success' | 'error'

  // Don't show banner if email is verified or user dismissed it
  if (!user || user.email_verified || dismissed) {
    return null;
  }

  const handleResend = async () => {
    setResending(true);
    setMessage('');
    setMessageType('');

    try {
      const response = await api.post('/api/auth/resend-verification');
      setMessageType('success');
      setMessage(response.data.message || 'Verification email sent! Please check your inbox.');
    } catch (error) {
      setMessageType('error');
      setMessage(
        error.response?.data?.detail ||
        'Failed to send verification email. Please try again later.'
      );
    } finally {
      setResending(false);
    }
  };

  const handleDismiss = () => {
    setDismissed(true);
  };

  return (
    <div className="email-verification-banner">
      <div className="banner-content">
        <div className="banner-icon">⚠️</div>
        <div className="banner-text">
          <strong>Email Verification Required</strong>
          <p>Please verify your email address to receive important notifications and updates.</p>
          {message && (
            <p className={`banner-message ${messageType}`}>
              {message}
            </p>
          )}
        </div>
        <div className="banner-actions">
          <button
            onClick={handleResend}
            disabled={resending}
            className="btn-resend"
          >
            {resending ? 'Sending...' : 'Resend Verification Email'}
          </button>
          <button
            onClick={handleDismiss}
            className="btn-dismiss"
            aria-label="Dismiss"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
}
